<ul color="warn">
  <li class="list-element-item">
    <span class="icon list-element-circle"></span>
    {{ listitem.Name }}
  </li>
  @if (checkedSubcategories.length > 0) {
    <li class="subcategories-list flex flex-col flex-start-stretch">
      {{ subcategoriesString }}
    </li>
  }
</ul>
